/* global require, Toasts, MediumEditor */
;$(function () {
  'use strict'
  const postDeleteSelector = '[data-post-delete]'
  const $postDeleteButton = $('[data-post-delete-action]')
  const commentDeleteSelector = '[data-comment-delete]'
  const $commentDeleteButton = $('[data-comment-delete-action]')
  const postTitleSelector = '[data-blog-post-title]'
  const commentsListSelector = '[data-blogs-comments]'
  const commentSelector = '[data-blogs-comment]'
  const postEditorSubmitSelector = '[data-blogpost-submit]'
  const postEditorSubmitBtnSelector = '[data-blogpost-submit-btn]'
  const $newCommentForm = document.querySelector('[data-blogs-new-comment-form]')
  const $postEditorForm = document.querySelector('[data-blogpost-form]')
  const $blogEditor = document.querySelector('[data-blog-editor]')
  const $commentEditor = $($newCommentForm).find('[data-blog-editor]')
  const $commentSendButton = $('[data-comment-send]')

  if ($postEditorForm) {
    $postEditorForm.addEventListener('submit', function (e) {
      e.preventDefault()
      const $form = this
      const $submitButtons = document.querySelectorAll(postEditorSubmitBtnSelector)
      for (var i = 0; i < $submitButtons.length; i++) {
        $submitButtons[i].disabled = true
      }
      $form.submit()
    })
  }

  $(document).on('click', postEditorSubmitSelector, function (e) {
    e.preventDefault()
    const $submitButtons = document.querySelectorAll(postEditorSubmitBtnSelector)
    for (var i = 0; i < $submitButtons.length; i++) {
      $submitButtons[i].disabled = true
    }
    $postEditorForm.submit()
  })

  $(document).on('keydown touchstart', postTitleSelector, function (e) {
    if ((e.keyCode || e.which) === 13) {
      e.preventDefault()
      var me = MediumEditor.getEditorFromElement($blogEditor)
      me.selectElement($blogEditor)
      $blogEditor.click()
      MediumEditor.selection.moveCursor(document, $blogEditor, 0)
      MediumEditor.selection.clearSelection(document)
    }
  })

  $(document).on('click', postDeleteSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const url = $this.data('url')
    $postDeleteButton.data('url', url)
  })

  $postDeleteButton.on('click', function (e) {
    e.preventDefault()

    const $this = $(this)
    const url = $this.data('url')

    if (!url) {
      Toasts.pushToast('Что-то пошло не так, попробуйте позднее', 'fail', undefined, 5000)
      return
    }

    $.post(
      url
    ).done(function (response) {
      document.location = response.url
    }).fail(function (xhr) {
      var errorMessage = 'Что-то пошло не так, попробуйте позднее'

      if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
        errorMessage = xhr.responseJSON.error
      }

      Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
    })
  })

  $(document).on('click', commentDeleteSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const url = $this.data('url')
    $commentDeleteButton.data('url', url)
    $commentDeleteButton.data('comment', $this.closest(commentSelector))
  })

  $commentDeleteButton.on('click', function (e) {
    e.preventDefault()

    const $this = $(this)
    const url = $this.data('url')
    const $comment = $this.data('comment')

    $.post(
      url
    ).done(function () {
      $comment.remove()

      Toasts.pushToast('Комментарий успешно удален.', 'success', undefined, 5000)

      var $modal = $this.parents('.modall')
      window.Modal.closeModal($modal)
    }).fail(function (xhr) {
      var errorMessage = 'Что-то пошло не так, попробуйте позднее'

      if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
        errorMessage = xhr.responseJSON.error
      }

      Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
    })
  })

  var $settingsIcon = $('.blogpost-settings__icon')
  var $settingsDrop = $('.blogpost-settings__drop')

  var addBackLayer = function () {
    var $backLayer = $('<div></div>')

    $backLayer.addClass('blogpost-settings__back-layer')
    $('body').append($backLayer)

    $backLayer.on('click', function () {
      $settingsIcon.removeClass('blogpost-settings__icon_active')
      $settingsDrop.removeClass('blogpost-settings__drop_active')
      $('.blogpost-settings__back-layer').remove()
      $('body').css('overflow', 'visible')
    })
  }

  if ($settingsIcon) {
    $settingsIcon.on('click', function () {
      $settingsIcon.toggleClass('blogpost-settings__icon_active')
      $settingsDrop.toggleClass('blogpost-settings__drop_active')

      if (document.querySelector('.blogpost-settings__back-layer')) {
        $('.blogpost-settings__back-layer').remove()
        $('body').css('overflow', 'visible')
      }
      else {
        addBackLayer()
        $('body').css('overflow', 'hidden')
      }
    })
  }

  var showPanel = function (elementSelector, scrollHeight) {
    var $panel = $(elementSelector)

    if ($panel.length) {
      window.onscroll = function () {
        if (document.body.scrollTop > scrollHeight || document.documentElement.scrollTop > scrollHeight) {
          $panel.css('display', 'block')
          $(document).trigger('Blogs::showPanel')
        }
        else {
          $panel.css('display', 'none')
        }
      }
    }
  }

  showPanel('[data-blogpost-panel]', 100)
  showPanel('[data-blogpost-editor-panel]', 60)

  // Unsubscription
  const subscriptionSelector = '[data-blogs-subscription]'
  const subscriptionConfirmSelector = '[data-blogs-subscription-confirm]'
  const $subscriptionConfirmButton = $(subscriptionConfirmSelector)
  const $subscriptionContainer = $('[data-blogs-subscription-container]')

  const subscribe = function (url, id, $confirmationButton) {
    const $subscribeElems = $(subscriptionSelector + '[data-action="subscribe"][data-id="' + id + '"]')
    const $unsubscribeElems = $subscribeElems.siblings(subscriptionSelector).filter('[data-action="unsubscribe"]')

    $.post(url, {'id': id})
      .done(function (response) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'
        if (response.success) {
          $subscribeElems.addClass('layout__none')
          $subscriptionContainer.removeClass('layout__none')
          if ($unsubscribeElems.length) {
            $unsubscribeElems.removeClass('layout__none')
            $subscriptionContainer.addClass('layout__none')
          }

          Toasts.pushToast('Вы успешно подписались', 'success', undefined, 5000)

          if ($confirmationButton) {
            var $modal = $confirmationButton.closest('.modall')
            window.Modal.closeModal($modal)
          }
        }
        else {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          errorMessage = xhr.responseJSON.error
        }

        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
      })
  }

  const unsubscribe = function (url, userId, $confirmationButton) {
    const $unsubscribeElems = $(subscriptionSelector + '[data-action="unsubscribe"][data-user-id="' + userId + '"]')
    const $subscribeElems = $unsubscribeElems.siblings(subscriptionSelector).filter('[data-action="subscribe"]')

    $.post(url, {'user_id': userId})
      .done(function (response) {
        $subscribeElems.data('id', response.id).attr('data-id', response.id)
        $subscribeElems.removeClass('layout__none')
        $unsubscribeElems.addClass('layout__none')

        Toasts.pushToast('Вы успешно отписались', 'success', undefined, 5000)

        if ($confirmationButton) {
          var $modal = $confirmationButton.closest('.modall')
          window.Modal.closeModal($modal)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          errorMessage = xhr.responseJSON.error
        }

        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
      })
  }

  $(document).on('click', subscriptionSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const action = $this.data('action')
    const url = $this.data('url')
    const id = $this.data('id')
    const userId = $this.data('userId')
    const errorMessage = 'Что-то пошло не так, попробуйте перезагузить страницу'
    const isConfirmationNeeded = $this.is('[data-blogs-subscription-need-confirmation]')

    if (action === 'subscribe') {
      if (!id) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }
    else if (action === 'unsubscribe') {
      if (!userId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }

    if (isConfirmationNeeded) {
      $subscriptionConfirmButton.data('action', action)
      $subscriptionConfirmButton.data('url', url)
      $subscriptionConfirmButton.data('userId', userId)
      $subscriptionConfirmButton.data('id', id)
      return
    }

    if (action === 'subscribe') {
      subscribe(url, id)
    }
    else if (action === 'unsubscribe') {
      unsubscribe(url, userId)
    }
  })

  $subscriptionConfirmButton.on('click', function (e) {
    e.preventDefault()

    const $this = $(this)
    const action = $this.data('action')
    const url = $this.data('url')
    const id = $this.data('id')
    const userId = $this.data('userId')
    const errorMessage = 'Что-то пошло не так, попробуйте перезагузить страницу'

    if (action === 'subscribe') {
      if (!id) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }
    else if (action === 'unsubscribe') {
      if (!userId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }

    if (action === 'subscribe') {
      subscribe(url, id, $this)
    }
    else if (action === 'unsubscribe') {
      unsubscribe(url, userId, $this)
    }
  })

  // Likes
  const likeActionSelector = '[data-blogs-like-action]'

  const likeAction = function ($actionElem, $wrapper) {
    const objectId = $wrapper.data('id')
    const url = $actionElem.data('url')
    const action = $actionElem.data('action')
    const $counter = $wrapper.find('[data-blogs-like-counter]')
    var counterSign

    if (action === 'like') {
      counterSign = 1
    }
    else {
      counterSign = -1
    }

    const $backwardActionElem = $wrapper.find(likeActionSelector).not($actionElem)

    $.post(url, {'id': objectId})
      .done(function (response) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'
        if (response.success) {
          $backwardActionElem.removeClass('layout__none')
          $actionElem.addClass('layout__none')
          const newAmount = parseInt($counter.text(), 10) + counterSign
          $counter.text(newAmount)

          if (newAmount === 0) {
            $counter.addClass('layout__none')
          }
          else {
            $counter.removeClass('layout__none')
          }
        }
        else {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
          errorMessage = xhr.responseJSON.error
        }

        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
      })
  }

  $(document).on('click', likeActionSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const $wrapper = $this.closest('[data-blogs-like]')

    likeAction($this, $wrapper)
  })

  // Replies
  const replyToSelector = '[data-reply-to-comment]'
  const $replyToInput = $('[data-new-comment-reply-to-input]')
  const $replyToBlock = $('[data-new-comment-reply-to]')
  const $replyToDelete = $replyToBlock.find('[data-new-comment-reply-to-delete]')
  const $replyToUserName = $replyToBlock.find('[data-new-comment-reply-to-user]')

  $(document).on('click', replyToSelector, function (e) {
    e.preventDefault()
    const $this = $(this)
    const commentId = $this.data('id')
    const userName = $this.data('userName')

    $replyToInput.val('' + commentId)
    $replyToBlock.removeClass('layout__none')
    $replyToUserName.text(userName)

    if ($('html').hasClass('iphone')) {
      $commentEditor.focus()
    }
    else {
      $('html').animate(
        {
          scrollTop: $commentEditor.offset().top - 120
        },
        'slow',
        function () {
          $commentEditor.focus()
        }
      )
    }
  })

  $replyToDelete.on('click', function () {
    $replyToInput.val(null)
    $replyToUserName.text('')
    $replyToBlock.addClass('layout__none')
  })

  // blink comment
  const blinkComment = function (commentId) {
    const comment = document.querySelector(commentSelector + '[data-id="' + commentId + '"]')
    if (!comment) {
      return
    }
    comment.style.animation = ''
    setTimeout(function () {
      comment.style.animation = 'comment_blink 4s linear 0s'
    }, 1)
  }

  // Go to comment
  const goToCommentSelector = '[data-blogs-go-to-comment]'

  const scrollToComment = function (commentId, withAnimation) {
    if (typeof withAnimation === 'undefined') {
      withAnimation = true
    }
    const $comment = $(commentSelector).filter('[data-id="' + commentId + '"]')
    if ($comment.length) {
      const commentTop = $comment.offset().top
      const scrollTop = commentTop - 50

      if (withAnimation) {
        $([document.documentElement, document.body]).animate({
          scrollTop: scrollTop
        }, 1000)
      }
      else {
        window.scrollTo(0, scrollTop)
      }

      document.location.hash = 'comment_' + commentId

      blinkComment(commentId)

      return true
    }

    return false
  }

  $(document).on('click', goToCommentSelector, function (e) {
    const $this = $(this)
    const commentId = $this.data('id')
    const isScrolled = scrollToComment(commentId)
    if (isScrolled) {
      e.preventDefault()
    }
    else {
      document.location = $this.attr('href')
    }
  })

  // blink selected comment
  const location_hash = document.location.hash
  if (location_hash && location_hash.search(/^#comment_(\d+)$/i) !== -1 ) {
    const selectedCommentId = parseInt(location_hash.match(/^#comment_(\d+)/i)[1], 10)
    blinkComment(selectedCommentId)
  }

  // new comment
  if ($newCommentForm) {
    $newCommentForm.addEventListener('submit', function (e) {
      e.preventDefault()

      const $form = this
      const $submitButtons = $form.querySelectorAll('[type="submit"]')

      for (var i = 0; i < $submitButtons.length; i++) {
        $submitButtons[i].disabled = true
      }

      var data = new FormData($form)

      $.ajax({
        url: $form.action,
        type: 'POST',
        processData: false,
        contentType: false,
        data: data
      })
        .done(function (response) {
          $replyToDelete.trigger('click')
          var me = MediumEditor.getEditorFromElement($blogEditor)
          if (me) {
            me.resetContent()
          }
          else {
            $form.querySelector('textarea').value = ''
          }

          const $comments = document.querySelector(commentsListSelector)
          var div = document.createElement('div')
          div.innerHTML = response
          const commentId = parseInt(div.querySelector(commentSelector).getAttribute('data-id'), 10)
          $comments.insertAdjacentHTML('beforeend', response)
          blinkComment(commentId)

          const $previewHidden = $('[data-comment-images-preview-hidden]')
          $previewHidden.val('')
          const $toolbar1 = $('#medium-editor-toolbar-1')
          $toolbar1.removeClass('medium-editor-toolbar-active')
          window.initPhotoOverlay()
        })
        .fail(function (xhr) {
          var errorMessage = 'Что-то пошло не так, попробуйте позднее'

          if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
            errorMessage = xhr.responseJSON.error
          }

          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        })
        .always(function () {
          for (var i = 0; i < $submitButtons.length; i++) {
            $submitButtons[i].disabled = false
          }
          $(document).trigger('Blogs::createComment')
        })
    })
  }

  // Send comment by ctrl + enter
  $commentEditor.keydown(function (e) {
    var enterCode = e.keyCode || e.which

    if (e.ctrlKey && enterCode === 13) {
      $commentSendButton.trigger('click')
    }
  })
})
